






















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Banner extends Vue {
    private title: string = 'The Nordic Brand';
    private curPage: string = '';
    private signedIn: string = '';

    private updatePage(newPage: string) {
        if (newPage !== this.curPage) {
            this.curPage = newPage;
            this.$emit('updatePage', newPage);
        }
    }

    get cSignedIn() {
        return this.signedIn;
    }

    set cSignedIn(newUser: string) {
        this.signedIn = newUser;
    }
}
